import React, { useContext, useRef } from "react";
import { SimpleContext } from "../../../../store/context/simple-context";
import { DESCRIPTION } from "../content/table.content";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../../helpers";
import TableHead from "./TableHead";
import Tab from "./Tab";
import "./index.scss";

const Table = ({ tableRef, period }) => {
  const {
    data: { tableState },
    translate: { t },
    update: { tableOpenHandler },
  } = useContext(SimpleContext);
  const tablePeriod = period || "common";
  const infoRef = useRef(null);
  return (
    <div
      className={getTrueClasses(
        "GP-C-T",
        !tableState[tablePeriod].open && "GP-C-T_hideInfo"
      )}
      ref={tableRef ? tableRef : infoRef}
    >
      <div
        className="GP-C-T__hide"
        onClick={() => tableOpenHandler(tablePeriod, false)}
      >
        {t("Hide")}
      </div>
      <TableHead />
      <ul className="GP-C-T-D">
        {DESCRIPTION.map(({ title, tab }, diIndex) => (
          <li
            key={title}
            className={getTrueClasses(
              "GP-C-T-D-I",
              `GP-C-T-D-I_di${diIndex + 1}`
            )}
          >
            <p className="GP-C-T-D-I__title">{t(title)}</p>
            <Tab tab={tab} diIndex={diIndex} period={period} />
          </li>
        ))}
      </ul>
    </div>
  );
};
Table.propTypes = {
  period: PropTypes.string,
};
export default Table;
